import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LessonTestResultEntity } from '@/entities/lesson-test-result.entity';
import APIBuilder from '@quangphuc/frontend-api-builder';

export default class LessonTestResultService
  extends CreateService<LessonTestResultEntity>('lesson-test-result')
  implements CRUDServiceInterface<LessonTestResultEntity>
{
  async getMany(): Promise<LessonTestResultEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }

  async getResultByLessonId(
    id: string | number,
  ): Promise<LessonTestResultEntity> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .filter('lessonId', '$eq', String(id))
      .getMany();
    return items[0];
  }

  async completeLessonTest(
    lessonId: string | number,
  ): Promise<LessonTestResultEntity> {
    const response = await APIBuilder.axios.post<LessonTestResultEntity>(
      `/${this.store}/complete`,
      {
        lessonId,
      },
    );
    return response.data;
  }
}
